import { FormattedMessage } from 'react-intl';
import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
import RoundShadowBox from '../../../components/RoundShadowBox';
import power from '../../../images/companyServices/battery-charging.svg';
import bike from '../../../images/companyServices/bike.svg';
import close from '../../../images/companyServices/close.svg';
import animal from '../../../images/companyServices/dog.svg';
import restroom from '../../../images/companyServices/drop.svg';
import ok from '../../../images/companyServices/ok.svg';
import meal from '../../../images/companyServices/restaurant.svg';
import airConditioning from '../../../images/companyServices/snow.svg';
import luggage from '../../../images/companyServices/suitcase-alt.svg';
import media from '../../../images/companyServices/video.svg';
import accessibility from '../../../images/companyServices/wheelchair.svg';
import wifi from '../../../images/companyServices/wifi.svg';
import {
  companyServicesPropTypes,
  SERVICE_ACCESSIBILITY,
  SERVICE_AIR_CONDITIONING,
  SERVICE_ANIMAL,
  SERVICE_BIKE,
  SERVICE_LUGGAGE,
  SERVICE_MEAL,
  SERVICE_MEDIA,
  SERVICE_POWER,
  SERVICE_RESTROOM,
  SERVICE_WIFI,
} from '../constants';
import messages from './messages';

const Container = styled(RoundShadowBox)`
  ${tw`flex flex-wrap justify-around px-def py-abs1 mb-abs4`};
`;

const Service = styled.div`
  ${tw`flex flex-row`};
  margin: 0.8rem;
`;

const Icon = styled.img`
  max-width: 3rem;
`;

const Text = styled.p`
  ${tw`whitespace-no-wrap`};
  padding-top: 0.2rem;
  margin-right: 0.5rem;
  margin-left: 0.5rem;
`;

const icons = {
  [SERVICE_POWER]: power,
  [SERVICE_WIFI]: wifi,
  [SERVICE_MEAL]: meal,
  [SERVICE_RESTROOM]: restroom,
  [SERVICE_MEDIA]: media,
  [SERVICE_AIR_CONDITIONING]: airConditioning,
  [SERVICE_LUGGAGE]: luggage,
  [SERVICE_BIKE]: bike,
  [SERVICE_ANIMAL]: animal,
  [SERVICE_ACCESSIBILITY]: accessibility,
};

const CompanyServices = ({ data }) => (
  <Container>
    {data.map((service) => (
      <Service key={service.id}>
        <Icon alt={service.id} src={icons[service.id]} />
        <Text>
          <FormattedMessage {...messages[service.id]} />
        </Text>
        <Icon src={service.value ? ok : close} />
      </Service>
    ))}
  </Container>
);

CompanyServices.propTypes = {
  data: companyServicesPropTypes,
};

export { CompanyServices };
